import React from 'react'
import YouTubePlaylist from "@codesweetly/react-youtube-playlist";
import styled from 'styled-components'

export default function Playlist() {
    return (
        <>
            <Container>
                <YouTubePlaylist
                    apiKey="AIzaSyCAl4Ri1XyzeKPXDLqkL_qhzlURmIdQzKU"
                    playlistId="PLwXMrrRNNVP1xIiFldv00uNyrKTSvL_38"
                    uniqueName="MFF_WORK"
                />
            </Container>
        </>
    )
}

const Container = styled.div`
display:flex;
flex-direction:column;
justify-content:center;
margin-top:20px;
margin: 2rem;
`